export default "__VITE_ASSET__Sb_3MDBw__"